import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLangifyNotificationAsUnviewed, setLangifyNotificationAsViewed, getLangifyNotifications, resetErrors } from '../../../modules/langifyNotifications';
import { useHistory, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Paper, Grid } from '@mui/material';
import ItemsList from '../../../components/ItemsList';
import ItemsListSkeleton from '../../../components/ItemsListSkeleton';
import LoadingIndicator from '../../../components/LoadingIndicator';
import EmptyView from '../../../components/EmptyView';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OptionsMenu from '../../../components/OptionsMenu';
import NewFlexItemList from '../../../components/NewFlexItemList';
import cloneDeep from 'lodash/cloneDeep';
import Link from '@mui/material/Link';
import { Trans, useTranslation } from 'react-i18next';
import { ThreeSixtySharp } from '@mui/icons-material';

import ProfileMenu from '../ProfileMenu.js';
import Ticketsystem from './Ticketsystem.js';

const Profile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();


  const [ticketSystemKey, setTicketSystemKey] = useState(Math.random()*100);

  const notifications = useSelector(state => state.langifyNotifications.notifications);
  const editLanguage = useSelector(state => state.shop.shop.edit_language);
  const shopUrl = useSelector(state => state.shop.shop.url);

  useEffect(() => {
    // Your effect logic here if needed
    console.log(id);
  }, []);

  const handelTicketsystemReload = (key) => {
    setTicketSystemKey(key + 1);
  }

  return (
    <React.Fragment>
      <Grid container spacing={3} alignItems="flex-start" className="page-content">
        <Grid size={12} className="page-content">
          <Typography variant="h4" component="h2">{t('Support Tickets')}</Typography>
          <Divider className="divider-white" />
        </Grid>
        <Grid size={12}>
          <Ticketsystem 
            key={ticketSystemKey}
            doReloadComponent={handelTicketsystemReload}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Profile;